import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import Faktory from '../../../../assets/imgs/logos/2025/faktory_branco.svg'
import '../../style.css'

const MaintenancFaktory: React.FC = () => {
    return(
        <div className="maintenance-container fak">
        <Row className="justify-content-center align-items-center vh-100">
          <Col md={6} className="text-center">
            <img src={Faktory} className="imgFaktory"/>
            <h1>Site em Manutenção</h1>
            <p>Estamos realizando atualizações para melhorar a sua experiência.</p>
            <p>Retornaremos em breve.</p>
  
            <Link to="/" className="mt-4 btn btn-light col">
              Página Inicial <BsArrowRight className="ml-2"/>
            </Link>
          </Col>
        </Row>
      </div>
      )
};
export default MaintenancFaktory;
